import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { PortabilityDocuments } from '../../../../shared/portability.models';

@Component({
  selector: 'gdp-upload-portability-docs-form',
  templateUrl: './upload-portability-docs-form.component.html',
  styleUrls: ['./upload-portability-docs-form.component.scss']
})
export class UploadPortabilityDocsFormComponent implements OnInit {
  @Input() country: string;
  public allowedExtensions = '.doc, .docx, .pdf, .jpg, .jpeg, .jpe, .png, .jfif, .tiff, .tif';
  // for internal validation
  private _allowedExtensions = [ ".doc", ".docx", ".pdf", ".jpg", ".jpeg", ".jpe", ".png", ".jfif", ".tiff", ".tif"];
  public files: PortabilityDocuments = {
    module: null,
    invoice: null,
    identity: null
  };
  public isHover: {
    module: boolean,
    invoice: boolean,
    identity: boolean
  } = {
    module: false,
    invoice: false,
    identity: false
  }
  public enableIdentity: boolean = false;
  public canSubmit: boolean = false;

  @Output() onEmitDocs: EventEmitter<{files: PortabilityDocuments, isValid: boolean}> = new EventEmitter();

  constructor(private renderer: Renderer2) {}

  ngOnInit() {
    this.enableIdentity = ['IT'].includes(this.country);
    this.onEmitValues();
  }

  public onChangeFile(evt: any, field: string):void{
    const file = evt.target.files[0];
    this.validateAndAcceptFile(file, field);
  }

  public onDrop(evt: DragEvent, field: string):void{
    // should avoid to open the file in a new window (browser behaviour)
    evt.preventDefault();
    if(evt.dataTransfer.types[0] === 'Files'){
      this.renderer.removeClass(evt.target, 'drop-zone-hover');
      const file = evt.dataTransfer.files[0];
      this.validateAndAcceptFile(file, field);
    }
  }

  public onDragOver(evt: DragEvent):void {
    // Mozilla documentation says to use also this to avoid strange file copy
    evt.preventDefault();
  }

  public onDragEnter(evt: DragEvent, el: HTMLElement): void{
    evt.stopPropagation();
    if(evt.dataTransfer.types[0] === 'Files'){
      this.renderer.addClass(el, 'drop-zone-hover');
    }
  }

  public onDragLeave(evt: DragEvent, el: HTMLElement): void{
    this.renderer.removeClass(el, 'drop-zone-hover');
  }

  private validateAndAcceptFile(file: File, field: string): void{
    if(this.validateSize(file) && this.validateExtension(file)){
      this.files[field] = file;
      this.canSubmit = this._canSubmit();
      this.onEmitValues();
    }
  }

  public removeFile(field: string, el: HTMLInputElement):void {
    if(this.files[field]){ 
      this.files[field] = null;
      // this is needed in case the upload is done via the input and not the drop
      // When selecting the same file, if value is set, no event will be thrown
      // So let's just put and empty string whenever we remove a file
      el.value = "";
      this.canSubmit = this._canSubmit();
      this.onEmitValues();
    }
  }

  private validateSize(file: File): boolean{
    return file?.size <= 5.243e+6; // 5.243e+6 => 5 MB
  }

  private validateExtension(file: File): boolean{
    const ext = file.name.substring(file.name.lastIndexOf('.'));
    return this._allowedExtensions.includes(ext);
  }

  private _canSubmit():boolean {
    switch (this.country) {
      case 'GB':
      case 'US':
        return !!(this.files.invoice && this.files.module);
      case 'IT':
        return !!(this.files.invoice && this.files.module && this.files.identity);
    }
  }

  private onEmitValues(): void {
    // if we add new countries it should be easier to extend with other documents
    if(!this.enableIdentity) delete this.files.identity;
      this.onEmitDocs.emit({files: this.files, isValid: this.canSubmit});
  }
}